import { SWRConfiguration } from 'swr';

import {
  useGetUnitPositionCustomData,
  useGetUnitPositionCustomDataAttributes,
} from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/data';

export const useUnitPositionCustomData = () => {
  const swrConfig: SWRConfiguration = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  };

  const {
    data: unitPositionCustomData,
    isLoading: isLoadingUnitPositionCustomData,
    failedToLoad: failedToLoadUnitPositionCustomData,
  } = useGetUnitPositionCustomData(swrConfig);

  const {
    data: unitPositionCustomDataAttributes,
    isLoading: isLoadingUnitPositionCustomDataAttributes,
    failedToLoad: failedToLoadUnitPositionCustomDataAttributes,
  } = useGetUnitPositionCustomDataAttributes(swrConfig);

  const isLoading =
    isLoadingUnitPositionCustomData ||
    isLoadingUnitPositionCustomDataAttributes;
  const failedToLoad =
    failedToLoadUnitPositionCustomData ||
    failedToLoadUnitPositionCustomDataAttributes;

  return {
    isLoading,
    failedToLoad,
    unitPositionCustomData,
    unitPositionCustomDataAttributes,
    showCustomData: unitPositionCustomData.length > 0,
  };
};
